import React from 'react';
import { Text, Textarea, VStack } from '@chakra-ui/react';
import ModalShell from '../../../../components/ui/ModalShell';
import { ff } from '../../../../theme';
import { SheetButton, SheetFooter, SheetHeader } from './sheetParts';

interface ExplainReasonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  onSubmit: (explanation: string) => void;
  brandName?: string;
}

/** Decline step 2 for "Other": the creator's own reason, sent as the decline reason. */
const ExplainDeclineReasonModal: React.FC<ExplainReasonModalProps> = ({ isOpen, onClose, onBack, onSubmit, brandName = 'the brand' }) => {
  const [explanation, setExplanation] = React.useState('');

  const handleSubmit = () => {
    onSubmit(explanation);
    onClose();
  };

  const handleBackAndClose = () => {
    onBack();
    onClose();
  };

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      hideClose
      footer={
        <SheetFooter>
          <SheetButton tone="outline" onClick={onClose}>Cancel</SheetButton>
          <SheetButton tone="red" onClick={handleSubmit} isDisabled={explanation.trim().length === 0}>
            Decline invite
          </SheetButton>
        </SheetFooter>
      }
    >
      <SheetHeader title="Decline invite" onClose={onClose} onBack={handleBackAndClose} step={{ index: 2, total: 2, name: 'Explain' }} />
      <VStack as="label" align="stretch" spacing="6px">
        <Text as="span" fontSize="14px" fontWeight={600} lineHeight="normal">
          Tell {brandName} why
        </Text>
        <Textarea
          placeholder="e.g. I am traveling most of November"
          value={explanation}
          onChange={e => setExplanation(e.target.value)}
          h="110px"
          px="14px"
          py="12px"
          borderRadius="14px"
          border={`1px solid ${ff.border}`}
          bg="white"
          fontSize="16px"
          color={ff.ink}
          resize="none"
          _hover={{ borderColor: ff.border }}
          _focusVisible={{ borderColor: ff.ink, boxShadow: `0 0 0 1px ${ff.ink}` }}
        />
      </VStack>
    </ModalShell>
  );
};

export default ExplainDeclineReasonModal;
